/** Cookies and browser storage actually used by the site. */
import type { InfoDoc } from "../types";

export const cookies: InfoDoc = {
  es: {
    title: "Política de cookies",
    intro: "Usamos lo necesario para que la tienda funcione y Google Analytics para entender cómo se usa el sitio y medir nuestros anuncios en Google. Podés rechazar la analítica cuando quieras.",
    sections: [
      {
        title: "Cookies que usamos",
        paragraphs: [
          "Sesión: cuando ingresás a tu cuenta guardamos una cookie de sesión segura (solo HTTPS, no accesible desde JavaScript) para mantenerte conectado. Se borra al cerrar sesión o al vencer.",
          "Seguridad de la red: Cloudflare, que protege y acelera el sitio, puede poner cookies técnicas para distinguir personas de bots. No se usan para publicidad.",
        ],
      },
      {
        title: "Analítica: Google Analytics",
        paragraphs: [
          "Usamos Google Analytics 4 (de Google LLC) para saber qué páginas se visitan, desde dónde llegan las visitas, con qué tipo de dispositivo y cómo funciona el proceso de compra (productos vistos, agregados al carrito y compras con su número de pedido y monto, sin tu nombre ni tu email).",
          "En Argentina y en la mayoría de los países está activo desde que entrás, y el aviso de cookies te lo informa. En la Unión Europea, el Reino Unido y Suiza empieza apagado y solo se activa si tocás «Entendido».",
          "Usa las cookies _ga y _ga_… , que duran hasta 2 años. Para saber si una visita llegó desde un anuncio nuestro en Google, también puede guardar cookies de Google Ads (_gcl_…), que duran hasta 90 días, y un dato parecido en el almacenamiento local del navegador. No las usamos para mostrarte publicidad. Google puede procesar estos datos fuera de Argentina, incluso en Estados Unidos.",
          "Si tocás «Rechazar», en el aviso o desde «Configurar cookies» al pie de cada página, borramos esas cookies y esos datos, y no se guardan más. Google sigue recibiendo avisos anónimos, sin cookies ni identificador tuyo (qué página, a qué hora, si aceptaste o no), que usa para estimar estadísticas en conjunto. Podés cambiar tu elección cuando quieras.",
        ],
      },
      {
        title: "Lo que guardamos en tu navegador",
        paragraphs: [
          "Además de cookies, el sitio guarda en el almacenamiento local de tu navegador: tu carrito, el idioma elegido, la moneda en la que ves los precios (US$ o AR$), si cerraste el aviso para instalar la app y tu elección sobre las cookies de analítica.",
          "Si tenés la sesión iniciada, el carrito también se guarda en tu cuenta para que lo encuentres en otro dispositivo.",
        ],
      },
      {
        title: "Pagos e ingreso con Google",
        paragraphs: [
          "Cuando pagás, te llevamos al sitio de Mercado Pago, Stripe o PayPal, y cuando ingresás con Google, al sitio de Google. Ahí rigen sus propias políticas de cookies.",
        ],
      },
      {
        title: "Cómo borrarlas",
        paragraphs: [
          "Podés borrar las cookies y el almacenamiento local desde la configuración de tu navegador. Si lo hacés, se cierra tu sesión y se vacía el carrito.",
          "Las cookies necesarias no se pueden rechazar porque sin ellas el sitio no funciona; las de analítica, sí, desde el aviso de cookies.",
        ],
      },
    ],
  },
  en: {
    title: "Cookie policy",
    intro: "We use what the store needs to work and Google Analytics to understand how the site is used and measure our ads on Google. You can reject analytics anytime.",
    sections: [
      {
        title: "Cookies we use",
        paragraphs: [
          "Session: when you sign in we store a secure session cookie (HTTPS only, not readable by JavaScript) to keep you signed in. It is removed when you sign out or when it expires.",
          "Network security: Cloudflare, which protects and speeds up the site, may set technical cookies to tell people from bots. They are not used for advertising.",
        ],
      },
      {
        title: "Analytics: Google Analytics",
        paragraphs: [
          "We use Google Analytics 4 (by Google LLC) to learn which pages are visited, where visits come from, what kind of device is used and how checkout works (products viewed, added to the cart and purchases with their order number and amount, without your name or email).",
          "In Argentina and most countries it is on from your first visit, and the cookie notice tells you so. In the European Union, the United Kingdom and Switzerland it starts off and only turns on if you tap «Got it».",
          "It uses the _ga and _ga_… cookies, which last up to 2 years. To know whether a visit came from one of our ads on Google, it may also set Google Ads cookies (_gcl_…), which last up to 90 days, and similar data in your browser's local storage. We don't use them to show you ads. Google may process this data outside Argentina, including in the United States.",
          "If you tap «Reject», on the notice or from «Cookie settings» at the bottom of every page, we delete those cookies and that data, and no more are stored. Google still receives anonymous signals, without cookies or any identifier of yours (which page, what time, whether you accepted), which it uses to estimate aggregate statistics. You can change your choice anytime.",
        ],
      },
      {
        title: "What we store in your browser",
        paragraphs: [
          "Besides cookies, the site keeps in your browser's local storage: your cart, your language, the currency you see prices in (US$ or AR$), whether you dismissed the install-app banner and your choice about analytics cookies.",
          "If you are signed in, your cart is also saved to your account so you find it on other devices.",
        ],
      },
      {
        title: "Payments and Google sign-in",
        paragraphs: ["When you pay you go to Mercado Pago, Stripe or PayPal, and when you sign in with Google, to Google. Their own cookie policies apply there."],
      },
      {
        title: "How to delete them",
        paragraphs: [
          "You can delete cookies and local storage from your browser settings. Doing so signs you out and empties your cart.",
          "Necessary cookies can't be rejected because the site doesn't work without them; analytics cookies can, from the cookie notice.",
        ],
      },
    ],
  },
};
